import { ReactNode } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

type GoogleRecaptchaProviderProps = {
  isRecaptchaDomain: boolean
  children: ReactNode
}

export const GoogleRecaptchaProvider = ({
  isRecaptchaDomain = false,
  children,
}: GoogleRecaptchaProviderProps) => {
  return (
    <GoogleReCaptchaProvider
      useRecaptchaNet={isRecaptchaDomain}
      useEnterprise
      reCaptchaKey={process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY}>
      {children}
    </GoogleReCaptchaProvider>
  )
}
